import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { Datalog } from 'src/app/models/datalog';
import { UserService } from './user.service';
import { environment } from 'src/environments/environment';
import { datalogMapper } from 'src/app/models/transforms';

@Injectable({
  providedIn: 'root',
})
export class DatalogService {

  datalogUrl: string;
  
    constructor(private http: HttpClient, userService: UserService) {
      this.datalogUrl = environment.api + `/api/${userService.getOrganisationId()}/datalog`;
    }
  
    getComponentDatalog(
      componentId: string,
      startDate: Date,
      endDate: Date
    ): Observable<Datalog[]> {
      let params = new HttpParams();
      if (startDate !== undefined) {
        params = params.set('StartTimeUtc', startDate.toISOString());
      }
      if (endDate !== undefined) {
        params = params.set('StopTimeUtc', endDate.toISOString());
      }
      return this.http
        .get<Datalog[]>(`${this.datalogUrl}/${componentId}/?${params.toString()}`)
        .pipe(
          map((datalogs) => {
            datalogs = datalogs.map((datalog) => datalogMapper(datalog));
            return datalogs;
          })
        );
    }
}
